import constants from '@/app-configs/constants'

export default [
  {
    path: '/letters',
    name: 'letters',
    component: () => import('@/views/letters/Letters.vue'),
    meta: {
      pageTitle: 'DEBTIA_LETTER_TEMPLATES',
      breadcrumb: [
        {
          text: 'DEBTIA_LETTER_TEMPLATES',
          active: true,
        },
      ],
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
    },
  },
]
